import { ComponentTypes } from "../const/componentTypes";
import { externalFormProtectTypes } from "../const/externalFormProtectTypes";
import { ITemplate, ITemplateComponent } from "../types/template_service_types";

export interface IFieldVisibilityContext {
    formRecord: Record<string, any>;
    components: ITemplateComponent[];
    template: ITemplate;
    enLanguageEnabled: boolean;
    language: string;
    isExternalUser: boolean;
}

const EN_LANGUAGE = "en";

const getRuValueForTranslate = (value: string, list: string[], list_en: string[]) => {
    const enListIndex = list_en.findIndex(v => v === value);
    if (enListIndex >= 0) {
        return list[enListIndex] ? list[enListIndex] : value;
    } else {
        return value;
    }
};

const checkboxValueToBoolean = (value: any) => {
    if (value === undefined) {
        return undefined;
    } else {
        return value === true || value === "true";
    }
};

export const isTemplateFieldVisible = (component: ITemplateComponent, ctx: IFieldVisibilityContext): boolean => {
    const { formRecord, components, template, enLanguageEnabled, language, isExternalUser } = ctx;

    if (isExternalUser && component.protect === externalFormProtectTypes.hide) {
        return false;
    }

    if (isExternalUser && component.type === ComponentTypes.iprocIntegration) {
        return false;
    }

    if (isExternalUser && component.type === ComponentTypes.hrPerson && component.readonly) {
        return false;
    }

    if (component.visibilityParentName) {
        const componentByTag = components.find(c => c.name === component.visibilityParentName);
        if (componentByTag?.type === ComponentTypes.file) {
            const fileValue = formRecord[component.visibilityParentName];
            const fileExists = !!fileValue && fileValue.length > 0;
            return component.visibilityParentNegate ? !fileExists : fileExists;
        } else if (componentByTag?.type === ComponentTypes.checkbox) {
            const checkboxValue = checkboxValueToBoolean(formRecord[component.visibilityParentName]);
            const compareValue = checkboxValueToBoolean(component.visibilityParentValue);
            if (checkboxValue === undefined || compareValue === undefined) {
                return false;
            } else {
                return component.visibilityParentNegate ? checkboxValue !== compareValue : checkboxValue === compareValue;
            }
        } else {
            if (String(component.visibilityParentValue)) {
                switch (component.visibilityParentName) {
                    case "docName":
                        const templateName = template.name;
                        return component.visibilityParentNegate ? templateName !== component.visibilityParentValue : templateName === component.visibilityParentValue;
                    case "docCode":
                        const templateCode = template.code;
                        return component.visibilityParentNegate ? templateCode !== component.visibilityParentValue : templateCode === component.visibilityParentValue;
                    default:
                        let stringValue = "";
                        const parentComponent = components.find(c => c.name === component.visibilityParentName);
                        const recordValue = formRecord[component.visibilityParentName];
                        if (recordValue === undefined) {
                            return false;
                        } else {
                            try {
                                if (typeof recordValue === "string") {
                                    if (enLanguageEnabled && language === EN_LANGUAGE && parentComponent && [ComponentTypes.radio, ComponentTypes.select, ComponentTypes.inputWithSelect].includes(parentComponent.type)) {
                                        // @ts-ignore
                                        stringValue = getRuValueForTranslate(recordValue, parentComponent.list, parentComponent.list_en);
                                    } else {
                                        stringValue = recordValue;
                                    }
                                } else {
                                    stringValue = recordValue.toString();
                                }
                            } catch (e) {
                                console.error(e);
                            }
                        }
                        return component.visibilityParentNegate ?
                            String(stringValue).trim() !== String(component.visibilityParentValue).trim() :
                            String(stringValue).trim() === String(component.visibilityParentValue).trim();
                }
            }
        }
    }

    return true;
};
